import React, { useState } from "react";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";
import { FiCalendar, FiArrowRight, FiCheckCircle } from "react-icons/fi";
import CustomModal from "../CustomModal/CustomModal";
import LandingPopupDemo from "./landingPopupDemo";

export const LandingVision: React.FC = () => {
  const [showPopUp, setShowPopUp] = useState(false);

  return (
    <section className="py-20 bg-slate-900 text-white relative overflow-hidden">
      {/* Background glow */}
      <div className="absolute top-0 right-1/3 w-96 h-96 bg-blue-600/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-1/3 w-96 h-96 bg-indigo-600/10 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16 relative z-10">
        
        {/* Vision Quote Box */}
        <div
          data-aos="fade-up"
          className="bg-slate-800/80 border border-slate-700/80 rounded-[2.5rem] p-8 sm:p-14 shadow-2xl backdrop-blur-xl max-w-5xl mx-auto relative"
        >
          <div className="flex justify-between items-start mb-6">
            <FaQuoteLeft className="text-3xl sm:text-5xl text-blue-500/40" />
            <span className="text-xs font-black uppercase tracking-widest text-blue-400 bg-blue-500/10 px-4 py-1.5 rounded-full border border-blue-500/20">
              Our Vision Statement
            </span>
          </div>

          <p className="text-base sm:text-2xl text-slate-200 font-medium leading-relaxed italic text-center sm:text-left">
            "Pendulum Digital envisions a world where education is universally accessible, transparent, and enhanced by cutting-edge technology. Our goal is to enable every school, teacher, parent, and student to thrive in a digital ecosystem that prioritizes real-time learning, collaboration, and growth."
          </p>

          <div className="flex justify-end mt-6">
            <FaQuoteRight className="text-3xl sm:text-5xl text-indigo-500/40" />
          </div>
        </div>

        {/* Demo Call To Action Banner */}
        <div
          data-aos="zoom-in"
          className="bg-gradient-to-r from-blue-600 via-indigo-600 to-teal-500 rounded-[2.5rem] p-8 sm:p-12 shadow-2xl text-white flex flex-col md:flex-row items-center justify-between gap-8"
        >
          <div className="space-y-3 text-center md:text-left max-w-xl">
            <span className="text-[10px] font-black uppercase tracking-widest bg-white/20 px-3 py-1 rounded-md text-white">
              Ready to Upgrade Your School?
            </span>
            <h3 className="text-2xl sm:text-4xl font-black leading-tight">
              Transform Your School Operations Today
            </h3>
            <p className="text-xs sm:text-sm text-blue-100 font-medium">
              Schedule a personalized walkthrough demo with our education technology experts.
            </p>
          </div>

          <button
            type="button"
            onClick={() => setShowPopUp(true)}
            className="px-8 py-4 rounded-2xl font-black text-xs uppercase tracking-widest bg-white text-blue-900 hover:bg-slate-100 shadow-xl transition-all flex items-center gap-2.5 shrink-0 hover:scale-105"
          >
            <FiCalendar size={16} /> Book A Free Demo <FiArrowRight size={16} />
          </button>
        </div>

      </div>

      {/* Book a Demo Modal */}
      {showPopUp && (
        <CustomModal
          title="Book a Free Demo"
          width={75}
          hideModal={() => setShowPopUp(false)}
        >
          <LandingPopupDemo />
        </CustomModal>
      )}
    </section>
  );
};

export default LandingVision;
